import { waHTMLToText, rightFormatTagForText } from '@nixi1/nx-channel-utils'

/**
 * Get content for content HTML
 * @param {string} text
 *
 * @returns {string}
 */
export function cleanContentHTML(text) {
  if (!text) return ''
  if (typeof text !== 'string') return ''

  let content = text.replace(/&amp;&nbsp;/g, ' ').replace(/&nbsp;/g, ' ')

  return rightFormatTagForText(content)
}

/**
 * Get content for channel
 * @param {string} text
 * @param {object} options
 * @param {boolean} options.isTemplate
 *
 * @returns {string}
 */
export function getContentForChannel(text, options = {}){
  const { isTemplate = false, /* channel */ } = options

  if (!text) return ''
  if (typeof text !== 'string') return ''

  let _content = text.replace(/\n$/, '')
  if (!isTemplate) {
    // _content = _content.replace(/(<p>[<br>]+<\/p>)+/g, (str) => {
    _content = _content.replace(/(<p>(<[^>]*>)*[<br>]+(<[^>]*>)*<\/p>)+/g, (str) => {
      const aBR = str.match(/<br>|<p><br><\/p>/g)
      return `${aBR.map(e => '\n').join('')}\n`
    })

    // _content = _content.replace(/<\/p><p>/g, '<br/>')
    // _content = _content.replace(/<p>/g, '')
    // _content = _content.replace(/<br\/>/g, '\n')
    // _content = _content.replace(/<br>/g, '\n')
    // _content = _content.replace(/<\/p>/g, '')
    _content = _content.replace(/&amp;/g, '&')
    _content = _content.replace(/&amp;&nbsp;/g, ' ')
    _content = _content.replace(/&nbsp;/g, ' ')
    _content = _content.replace(/&gt;/g, '>')
    _content = _content.replace(/&lt;/g, '<')
  }

  // if (channel === 'whatsapp') {
  //   _content = _.replace(_content, /<strong>/g, '*')
  //   _content = _.replace(_content, /<\/strong>/g, '*')
  //   _content = _.replace(_content, /<em>/g, '_')
  //   _content = _.replace(_content, /<\/em>/g, '_')
  // } else if (channel === 'telegram') {
  //   _content = _.replace(_content, /<strong>/g, '<b>')
  //   _content = _.replace(_content, /<\/strong>/g, '</b>')
  //   _content = _.replace(_content, /<em>/g, '<i>')
  //   _content = _.replace(_content, /<\/em>/g, '</i>')
  // }

  return _content
}

/**
 * Get content to clipboard
 * @param {object} params
 * @param {string} params.text
 * @param {[object]} params.files
 * @param {[object]} params.buttons
 * @param {string} params.channel
 *
 * @returns {string}
 */
export function getContentToClipboard(params) {
  const { channel, text, files, buttons } = params

  let _buttons = null
  let attachment = null
  let value = waHTMLToText.replace(text)

  if (files) {
    files.forEach((it, index) => {
      attachment = `${index === 0 ? '' : '\n'}${it.url || it.urlLong}`
    })

    if (attachment) value = `${value}${'\n\n' + attachment}`
  }

  if (buttons) {
    buttons.forEach((it, index) => {
      if (channel === 'whatsapp') _buttons = `${index === 0 ? '' : _buttons + '\n\n'}*${it.label}*\n${it.content}`
      else _buttons = `${index === 0 ? '' : _buttons + '\n\n'}${it.label}\n${it.content}`
    })
    if (_buttons) value = `${value}${'\n\n' + _buttons}`
  }

  return value
}